export enum RaceTypes {
    RANKED = 'RANKED',
    UNRANKED = 'UNRANKED',
    FREEROOM = 'FREEROOM',
    TRAINING = 'TRAINING',
    GHOST = 'GHOST',
}